import { parseValidDates, formatMonthYearLabel, tooltipLabelFormatter, fallbackRangeLabel, buildPercentBreakdownForRow, toIsoDateUTC, makeDefaultRange14, buildDateRangeArray, dayFmt, CHART_COLORS, LABEL_MAP } from './dataQuality.helpers';
export { parseValidDates, formatMonthYearLabel, tooltipLabelFormatter, fallbackRangeLabel, CHART_COLORS, LABEL_MAP };
export function buildQualitySeries(data = [], effectiveRange) {
  let range = null;
  if (effectiveRange && (effectiveRange.start || effectiveRange.end)) {
    range = { start: effectiveRange.start || effectiveRange.end, end: effectiveRange.end || effectiveRange.start };
  } else {
    const dates = parseValidDates(data);
    if (dates.length) {
      const sorted = dates.slice().sort((a, b) => a - b);
      range = { start: toIsoDateUTC(sorted[0]), end: toIsoDateUTC(sorted[sorted.length - 1]) };
    } else {
      range = makeDefaultRange14();
    }
  }
  const dateArray = buildDateRangeArray(range.start, range.end);
  const map = new Map();
  for (const row of Array.isArray(data) ? data : []) {
    const key = row?.ReadingDate ? toIsoDateUTC(row.ReadingDate) : '';
    if (!key) continue;
    map.set(key, row);
  }
  return dateArray.map((dateObj) => {
    const iso = toIsoDateUTC(dateObj);
    const row = map.get(iso);
    const valuesByKey = {
      Missing_Type7: Number(row?.Missing_Type7) || 0,
      Actual:        Number(row?.Actual) || 0,
      Missing_Type9: Number(row?.Missing_Type9) || 0,
      Uncertain:     Number(row?.Uncertain) || 0,
      PendingMissing: Number(row?.PendingMissing) || 0,
    };
    const day = dayFmt.format(dateObj);
    const fullDate = dateObj.toLocaleDateString('en-GB');
    const { decimalsByKey, displayByKey } = buildPercentBreakdownForRow(valuesByKey);
    return {
      iso,
      day,
      fullDate,
      ...decimalsByKey,
      __display: displayByKey,
      __raw: valuesByKey,
    };
  });
}
